<template>
  <div
    :id="item.id"
    class="release-card">
    <div class="flex flex-wrap">
      <div class="release-card__col-1">
        <div class="pb-5 h3-headline">
          {{ noIndex ? '' : '#' + (item.number + 1) }} {{ english_lang ? item.nameEng : item.name }}
        </div>
        <div
          class="release-card__card-text">
          {{ english_lang ? item.descriptionEng : item.description }}
        </div>
        <sButton
          v-if="english_lang ? item.linkEng : item.link"
          class="mt-2"
          :href=" (english_lang ? item.linkEng : item.link) || '/futures#' + item.id "
          small
          :target="( english_lang ? item.linkEng : item.link ) ? '_blank' : '_self'"
          type="text">
          {{ $t('Tenders.ReadMore') }}
        </sButton>
      </div>
      <div class="release-card__col-2">
        <div class="flex flex-direction-column align-bottom">
          <StatusChip
            class="mb-2"
            :name="$t('Releases.' + item.type)"
            :status="item.type"/>
          <StatusChip
            v-if="!client"
            key-name="id"
            :status="{title: $t('Releases.' +
              ( item.isPublished ? 'Approved' : 'PendingApproval')) , id: item.isPublished }"
            value-name="title"/>
        </div>

        <div
          v-if="!client"
          class="ml-1">
          <v-menu
            content-class="feature-card-options-menu menu"
            left
            offset-x
            offset-y>
            <template v-slot:activator="{ on }">
              <sButton
                icon="menu"
                small
                type="text"
                v-on="on"/>
            </template>
            <div>
              <router-link :to="{name:'newFeature', params: {id: item.id, releaseId: item.releaseId, org: $route.params.org} }">
                <MenuItem
                  data-qa="releases-edit-description"
                  icon="edit"
                  :label="bigFirstLetter($t('Releases.EditDescription'))"/>
              </router-link>
              <MenuItem
                data-qa="purchasing-remove"
                icon="delete"
                :label="$t('Purchasing.Remove')"
                @click="deleteFeature"/>
            </div>
          </v-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import { modalMixin, releaseMixin } from 'mixins'

export default {
  name: 'featureCard',
  data() {
    return {
      comments: [],
    }
  },
  mixins: [ modalMixin, releaseMixin ],
  props: {
    item: Object,
    release: Object,
    index: Number,
    client: Boolean,
    'no-index': Boolean
  },
  computed: {
    english_lang() {
      return this.$i18n.locale == 'en'
    },
  },
  methods: {
    deleteFeature() {
      this.$store.dispatch('deleteFeature', this.item)
        .then(() => {
          this.$emit('action', null, this.release?.features)
        })
    },
  },
  components: {
    MenuItem,
    StatusChip
  }
}
</script>
<style lang="scss" scoped>
.release-card {
  font-size: 16px;
  text-align: left;
  line-height: 1.5;
  transition-property: box-shadow, opacity, -webkit-box-shadow;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  width: 100%;
  flex: 0 0 100%;
  max-width: 100%;
  box-shadow: 0px 0px 0px 0px rgba(var(--black-color-rgba), 0.2), 0px 0px 0px 0px rgba(var(--black-color-rgba), 0.14), 0px 0px 0px 0px rgba(var(--black-color-rgba), 0.12);
  margin-bottom: 12px;
  padding: 28px 20px 20px 32px;
  color: rgba(var(--black-color-rgba), 0.87);
  border-radius: 8px;
  background-color: var(--v-main__light_green-base);
  border-color: var(--v-main__light_green-base);
  &__col-1,
  &__col-2 {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  &__col-1 {
    flex: 0 0 58%;
    max-width: 58%;
    padding-right: 24px;
  }
  &__col-2 {
    display: flex;
    justify-content: flex-end;
  }
  &__card-text {
    white-space: pre-line;
    width: 100%;
    font-size: 14px;
  }
}
</style>
